/**
 * Product Summary - 商品小计功能
 * 从表单中获取商品信息并显示商品小计
 */

// 公共方法：获取表单数据
window.ProductSummary = {
  sectionId: "",
  /**
   * 从表单中获取商品数据
   * @param {HTMLFormElement|string} form - 表单元素或表单ID
   * @returns {Object} 包含 variantId, quantity, options, price 的对象
   */
  getFormData: function (form) {
    if (typeof form === "string") {
      form = document.getElementById(form) || document.querySelector(form);
    }

    if (!form || form.tagName !== "FORM") {
      console.warn("ProductSummary: Form not found");
      return null;
    }

    const formData = new FormData(form);
    const variantId = formData.get("id");
    const quantity = parseInt(formData.get("quantity") || "1", 10);

    // 获取商品选项信息
    const options = this.getProductOptions(form);

    // 获取价格信息
    const { price, discountPrice, regularPrice } = this.getVariantPrice(
      variantId,
      form,
    );

    return {
      variantId: variantId,
      quantity: quantity,
      options: options || [],
      price: price,
      discountPrice: discountPrice,
      regularPrice: regularPrice,
    };
  },

  /**
   * 获取商品选项信息
   * @param {HTMLFormElement} form - 表单元素
   * @returns {Array} 选项数组 [{name: 'Color', value: 'Red'}, ...]
   */
  getProductOptions: function (form) {
    const options = [];

    // 方法4: 从 [variant-selects] 获取， [variant-selects]变体配置是shopify自带的产品配置，优先判断读取该项
    const variantSelects = form
      .closest("product-info")
      ?.querySelector("variant-selects");
    if (variantSelects) {
      const optionFields = variantSelects.querySelectorAll(
        "fieldset, .product-form__input",
      );
      optionFields.forEach((field) => {
        const label = field.querySelector("legend, label");
        let optionName = label
          ? label.textContent.trim().split(":")[0].trim()
          : "";

        if (!optionName) return;

        let selectedValue = "";
        const select = field.querySelector("select");
        const checkedInput = field.querySelector("input:checked");

        if (select && select.selectedOptions.length > 0) {
          selectedValue = select.selectedOptions[0].textContent.trim();
        } else if (checkedInput) {
          selectedValue =
            checkedInput.value ||
            checkedInput.closest("label")?.textContent.trim() ||
            "";
        }

        if (optionName && selectedValue) {
          options.push({ name: optionName, value: selectedValue });
        }
      });

      if (options.length > 0) {
        return options;
      }
    }

    // ------ 下述是适配插件： VO Product Options 获取所有产品属性
    // 支持 radio、checkbox、普通 input 和 select，对于 radio 只处理被选中的
    const dataFieldInputsV2 = document.querySelectorAll(
      "input[data-gtm-form-interact-field-id], select[data-gtm-form-interact-field-id]",
    );
    if (dataFieldInputsV2.length > 0) {
      dataFieldInputsV2.forEach((element) => {
        // 对于 radio 类型，只处理被选中的；对于其他类型，直接处理
        if (element.type === "radio" && !element.checked) {
          return;
        }
        const fieldName = element.getAttribute("name");
        // 对于 select 元素，获取选中项的值；对于 input 元素，直接获取 value
        let fieldValue = "";
        if (element.tagName === "SELECT") {
          // select 元素：获取选中项的 value，如果没有 value 则获取文本内容
          const selectedOption = element.options[element.selectedIndex];
          fieldValue = selectedOption
            ? selectedOption.value || selectedOption.textContent.trim()
            : "";
        } else {
          fieldValue = element.value;
        }
        // 过滤掉数量，数量另外取
        if (fieldName && fieldValue && fieldName !== "quantity") {
          // 提取方括号中的内容，例如 properties[Color] -> Color
          const match = fieldName.match(/\[(.*?)\]/);
          let extractedName = match ? match[1] : fieldName;
          // 找不到插件中的配置，额外处理name0
          if (extractedName === "name0") {
            extractedName = "Color";
          }
          options.push({
            name: extractedName.trim(),
            value: fieldValue.trim(),
          });
        }
      });
      if (options.length > 0) {
        return options;
      }
    }

    // ------ 下述是适配插件： Globo Product Options 获取所有产品属性

    // 方法1: 从表单中获取所有带有 data-field-name 和 data-value 的 input 元素（优先方法）
    const dataFieldInputs = form.querySelectorAll(
      "input[data-field-name][data-value]",
    );
    if (dataFieldInputs.length > 0) {
      dataFieldInputs.forEach((input) => {
        const fieldName = input.getAttribute("data-field-name");
        const fieldValue = input.getAttribute("data-value");
        if (fieldName && fieldValue) {
          options.push({ name: fieldName.trim(), value: fieldValue.trim() });
        }
      });
      if (options.length > 0) {
        return options;
      }
    }

    // 方法2: 从表单中获取所有带有 data-field-name 的 input 元素（值从 value 属性获取）
    const dataFieldNameInputs = form.querySelectorAll("input[data-field-name]");
    if (dataFieldNameInputs.length > 0) {
      dataFieldNameInputs.forEach((input) => {
        const fieldName = input.getAttribute("data-field-name");
        const fieldValue = input.getAttribute("data-value") || input.value;
        if (fieldName && fieldValue) {
          options.push({ name: fieldName.trim(), value: fieldValue.trim() });
        }
      });
      if (options.length > 0) {
        return options;
      }
    }

    // 方法3: 从 SelectedVariantInfo 获取（如果存在，作为后备方案）
    const sectionId = form.closest("[data-section-id]")?.dataset.sectionId;
    if (sectionId) {
      const variantInfoContainer = document.getElementById(
        `SelectedVariantInfo-${sectionId}`,
      );
      if (variantInfoContainer) {
        const optionElements = variantInfoContainer.querySelectorAll(
          ".selected-variant-info__option",
        );
        optionElements.forEach((optionEl) => {
          const label = optionEl
            .querySelector(".selected-variant-info__option-label")
            ?.textContent.replace(":", "")
            .trim();
          const value = optionEl
            .querySelector(".selected-variant-info__option-value")
            ?.textContent.trim();
          if (label && value) {
            options.push({ name: label, value: value });
          }
        });
        if (options.length > 0) {
          return options;
        }
      }
    }

    // 方法5: 从 variant ID 反推（通过 variant data，作为最后的后备方案）
    const variantId = form.querySelector('[name="id"]')?.value;
    if (variantId) {
      const productInfo = form.closest("product-info");
      if (productInfo) {
        const variantDataScript = productInfo.querySelector(
          "variant-selects script[data-selected-variant]",
        );
        if (variantDataScript) {
          try {
            const variantData = JSON.parse(variantDataScript.textContent);
            if (
              variantData &&
              variantData.id === parseInt(variantId) &&
              variantData.options
            ) {
              const variantSelects =
                productInfo.querySelector("variant-selects");
              if (variantSelects) {
                const optionLabels =
                  variantSelects.querySelectorAll("legend, label");
                variantData.options.forEach((value, index) => {
                  if (value) {
                    const label = optionLabels[index];
                    const optionName = label
                      ? label.textContent
                          .trim()
                          .replace(":", "")
                          .replace("*", "")
                          .trim()
                      : `Option ${index + 1}`;
                    options.push({ name: optionName, value: value });
                  }
                });
              }
            }
          } catch (e) {
            console.warn("ProductSummary: Failed to parse variant data", e);
          }
        }
      }
    }

    return options;
  },

  /**
   * 获取变体价格
   * @param {string} variantId - 变体ID
   * @param {HTMLFormElement} form - 表单元素
   * @returns {number|null} 价格（以分为单位）
   */
  getVariantPrice: function (variantId, form) {
    if (!variantId) return null;
    const sectionId = form.closest("[data-section-id]")?.dataset.sectionId;
    if (sectionId) {
      const discountFlag = document.querySelector(
        `#price-${sectionId} .f-price--on-sale`,
      )
        ? true
        : false;
      let priceElement = null,
        discountPriceElement = null;
      let price = null,
        discountPrice = null;
      if (discountFlag) {
        // 如果是有折扣
        priceElement = document.querySelector(
          `#price-${sectionId} .f-price__sale .f-price-item--regular`,
        );
        discountPriceElement = document.querySelector(
          `#price-${sectionId} .f-price__sale .f-price-item--sale`,
        );
        price = (priceElement.textContent || priceElement.innerText)
          .match(/[\d,]+\.?\d*/)[0]
          .replace(/,/g, "");
        discountPrice = (
          discountPriceElement.textContent || discountPriceElement.innerText
        )
          .match(/[\d,]+\.?\d*/)[0]
          .replace(/,/g, "");
      } else {
        // 没有折扣场景
        priceElement = document.querySelector(
          `#price-${sectionId} .f-price__regular .f-price-item--regular`,
        );
        price = (priceElement.textContent || priceElement.innerText)
          .match(/[\d,]+\.?\d*/)[0]
          .replace(/,/g, "");
      }

      return {
        price: parseFloat(price) * 100,
        discountPrice: parseFloat(discountPrice) * 100,
        regularPrice: parseFloat(price) * 100,
      };
    }

    return null;
  },

  /**
   * 格式化价格显示
   * @param {number} priceInCents - 价格（以分为单位）
   * @returns {string} 格式化后的价格字符串
   */
  formatPrice: function (priceInCents) {
    if (!priceInCents) return "-";

    // 优先使用 Shopify 的货币格式化
    if (
      window.FoxTheme &&
      window.FoxTheme.Currency &&
      window.FoxTheme.Currency.formatMoney
    ) {
      // 使用主题设置中的货币格式，如果没有则尝试从页面中获取
      const moneyFormat =
        FoxTheme.settings?.moneyFormat ||
        this._getMoneyFormatFromPage() ||
        "{{amount}}";
      return FoxTheme.Currency.formatMoney(priceInCents, moneyFormat);
    }

    // Fallback: 尝试从页面中获取货币格式示例
    const moneyFormat = this._getMoneyFormatFromPage();
    if (moneyFormat) {
      // 简单的格式解析和替换
      const price = (priceInCents / 100).toFixed(2);
      const formattedPrice = price.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, formattedPrice);
    }

    // 最后的 fallback: 使用 Intl.NumberFormat 根据 locale 格式化
    const price = priceInCents / 100;
    try {
      // 尝试从页面或浏览器获取货币信息
      const locale = document.documentElement.lang || "en-US";
      const currencyCode = this._getCurrencyCodeFromPage() || "USD";
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currencyCode,
      }).format(price);
    } catch (e) {
      // 如果都失败了，至少显示数字格式
      return price.toFixed(2);
    }
  },

  /**
   * 从页面中获取货币格式
   * @returns {string|null} 货币格式字符串，如 '${{amount}}' 或 '€{{amount}}'
   */
  _getMoneyFormatFromPage: function () {
    // 尝试从已存在的价格元素中提取格式
    const priceElement = document.querySelector(
      ".f-price-item--regular, .price__regular, [data-price]",
    );
    if (priceElement) {
      const priceText = priceElement.textContent.trim();
      // 尝试匹配常见的货币格式模式
      const match = priceText.match(/^([^\d]*)([\d,.\s]+)([^\d]*)$/);
      if (match) {
        const prefix = match[1] || "";
        const suffix = match[3] || "";
        // 如果找到货币符号，构建格式字符串
        if (prefix || suffix) {
          return prefix + "{{amount}}" + suffix;
        }
      }
    }

    // 尝试从 FoxTheme.settings 获取（如果已加载但 formatMoney 不可用）
    if (
      window.FoxTheme &&
      window.FoxTheme.settings &&
      window.FoxTheme.settings.moneyFormat
    ) {
      return window.FoxTheme.settings.moneyFormat;
    }

    return null;
  },

  /**
   * 从页面中获取货币代码
   * @returns {string|null} 货币代码，如 'USD', 'EUR', 'CNY'
   */
  _getCurrencyCodeFromPage: function () {
    // 尝试从 meta 标签获取
    const currencyMeta = document.querySelector(
      'meta[property="product:price:currency"]',
    );
    if (currencyMeta) {
      return currencyMeta.getAttribute("content");
    }

    // 尝试从已存在的价格元素中推断
    const priceElement = document.querySelector(
      ".f-price-item--regular, .price__regular",
    );
    if (priceElement) {
      const priceText = priceElement.textContent.trim();
      // 常见货币符号映射（按优先级排序，更具体的符号在前）
      const currencySymbols = [
        { symbol: "A$", code: "AUD" },
        { symbol: "C$", code: "CAD" },
        { symbol: "₹", code: "INR" },
        { symbol: "€", code: "EUR" },
        { symbol: "£", code: "GBP" },
        { symbol: "$", code: "USD" },
        { symbol: "¥", code: this._inferYenCurrency() }, // 根据上下文推断是 JPY 还是 CNY
      ];

      for (const { symbol, code } of currencySymbols) {
        if (priceText.includes(symbol)) {
          return code;
        }
      }
    }

    return null;
  },

  /**
   * 推断 ¥ 符号是日元还是人民币
   * @returns {string} 'JPY' 或 'CNY'
   */
  _inferYenCurrency: function () {
    // 根据 locale 推断
    const locale = document.documentElement.lang || "";
    if (locale.includes("zh-CN") || locale.includes("zh_CN")) {
      return "CNY";
    }
    if (locale.includes("ja") || locale.includes("JP")) {
      return "JPY";
    }

    // 根据页面 URL 或域名推断
    const hostname = window.location.hostname;
    if (hostname.includes(".cn") || hostname.includes("china")) {
      return "CNY";
    }
    if (hostname.includes(".jp") || hostname.includes("japan")) {
      return "JPY";
    }

    // 默认返回 JPY（更常见）
    return "JPY";
  },

  /**
   * 更新所有 quantity-input 组件的状态
   * @param {string} sectionId - Section ID（可选，不提供则更新所有）
   * @param {number} quantity - 数量值（可选，不提供则从输入框读取）
   */
  updateQuantityInputs: function (sectionId, quantity) {
    // 找到所有相关的 quantity-input 组件
    let quantityInputs = [];

    if (sectionId) {
      // 方法1: 通过 data-section-id 属性查找
      const inputsBySectionId = document.querySelectorAll(
        `quantity-input[data-section-id="${sectionId}"]`,
      );
      quantityInputs = Array.from(inputsBySectionId);

      // 方法2: 在包含该 sectionId 的容器中查找
      const section = document.querySelector(
        `[data-section-id="${sectionId}"]`,
      );
      if (section) {
        const inputsInSection = Array.from(
          section.querySelectorAll("quantity-input"),
        );
        // 合并并去重
        inputsInSection.forEach((input) => {
          if (!quantityInputs.includes(input)) {
            quantityInputs.push(input);
          }
        });
      }

      // 方法3: 更新 sticky-atc-bar 中的 quantity-input（通常与主产品关联）
      const stickyBar = document.querySelector(".sticky-atc-bar");
      if (stickyBar) {
        const stickyQuantityInputs = Array.from(
          stickyBar.querySelectorAll("quantity-input"),
        );
        stickyQuantityInputs.forEach((input) => {
          if (!quantityInputs.includes(input)) {
            quantityInputs.push(input);
          }
        });
      }

      // 方法4: 通过 Quantity-{sectionId} 输入框查找其父级 quantity-input
      const quantityInputById = document.getElementById(
        `Quantity-${sectionId}`,
      );
      if (quantityInputById) {
        const parentQuantityInput = quantityInputById.closest("quantity-input");
        if (
          parentQuantityInput &&
          !quantityInputs.includes(parentQuantityInput)
        ) {
          quantityInputs.push(parentQuantityInput);
        }
      }
    } else {
      // 更新页面所有 quantity-input
      quantityInputs = Array.from(document.querySelectorAll("quantity-input"));
    }

    // 更新每个 quantity-input 组件
    quantityInputs.forEach((quantityInput) => {
      const input = quantityInput.querySelector('input[name="quantity"]');
      if (input) {
        // 如果提供了数量值，更新输入框的值
        if (quantity !== undefined && quantity !== null) {
          input.value = quantity;
        }

        // 触发 change 事件，让组件自己更新状态
        // 使用 setTimeout 确保值已经更新
        setTimeout(() => {
          if (
            quantityInput.validateQtyRules &&
            typeof quantityInput.validateQtyRules === "function"
          ) {
            quantityInput.validateQtyRules();
          } else {
            // 如果方法不存在，触发 change 事件
            const changeEvent = new Event("change", { bubbles: true });
            input.dispatchEvent(changeEvent);
          }
        }, 0);
      }
    });
  },

  /**
   * 更新商品小计显示
   * @param {string|HTMLElement} containerId - 容器ID或元素
   * @param {Object} data - 商品数据对象
   */
  updateSummary: function (containerId, data) {
    if (typeof containerId === "string") {
      containerId = document.getElementById(containerId);
    }

    if (!containerId) {
      console.warn("ProductSummary: Container not found");
      return;
    }

    const sectionId = containerId.dataset.sectionId;
    if (!sectionId) {
      console.warn("ProductSummary: Section ID not found");
      return;
    }

    // 更新选项显示
    const optionsContainer = document.getElementById(
      `ProductSummaryOptions-${sectionId}`,
    );
    if (optionsContainer) {
      if (data.options && data.options.length > 0) {
        optionsContainer.innerHTML = data.options
          .map((option) => {
            return `<div class="product-summary__option-item">
            <span class="product-summary__option-name">${this.escapeHtml(
              option.name,
            )}:</span>
            <span class="product-summary__option-value">${this.escapeHtml(
              option.value,
            )}</span>
          </div>`;
          })
          .join("");
      }
      // else {
      //   optionsContainer.innerHTML = '<span class="product-summary__default">Default</span>';
      // }
    }

    // 更新数量显示
    const quantityElement = document.getElementById(
      `ProductSummaryQuantity-${sectionId}`,
    );
    if (quantityElement) {
      quantityElement.textContent = data.quantity || "1";
    }
    const quantityInput = document.getElementById(`Quantity-${sectionId}`);
    if (quantityInput) {
      quantityInput.value = data.quantity || "1";
    }

    // 更新所有 quantity-input 组件的状态
    this.updateQuantityInputs(sectionId, data.quantity || 1);

    // 更新价格显示
    const priceElement = document.getElementById(
      `ProductSummaryPrice-${sectionId}`,
    );
    if (priceElement) {
      if (data.discountPrice) {
        priceElement.innerHTML = `${this.formatPrice(
          data.discountPrice * (data.quantity || 1),
        )} <s class="product-summary__price-value-regular">${this.formatPrice(
          data.regularPrice * (data.quantity || 1),
        )}</s>`;
      } else if (data.price) {
        priceElement.textContent = this.formatPrice(
          data.price * (data.quantity || 1),
        );
      } else {
        priceElement.textContent = "-";
      }

      // if (data.totalPrice) {
      //   priceElement.textContent = this.formatPrice(data.totalPrice);
      // } else if (data.price) {
      //   priceElement.textContent = this.formatPrice(data.price * (data.quantity || 1));
      // } else {
      //   priceElement.textContent = '-';
      // }
    }

    this.updateBottomBar(data);
    // 隐藏强行显示立刻支付的逻辑
    // updateBuyItNowButton();
  },

  /**
   * * @param {Object} data - 商品数据对象
   */
  updateBottomBar: function (data) {
    // 更新数量
    const quantityInput = document.getElementById(`Quantity-sticky-atc-bar`);
    if (quantityInput) {
      quantityInput.value = data.quantity || "1";
    }

    // 更新 sticky-atc-bar 中的 quantity-input 组件状态
    const stickyBar = document.querySelector(".sticky-atc-bar");
    if (stickyBar) {
      const stickyQuantityInputs = Array.from(
        stickyBar.querySelectorAll("quantity-input"),
      );
      stickyQuantityInputs.forEach((quantityInput) => {
        const input = quantityInput.querySelector('input[name="quantity"]');
        if (input) {
          input.value = data.quantity || "1";
          setTimeout(() => {
            if (
              quantityInput.validateQtyRules &&
              typeof quantityInput.validateQtyRules === "function"
            ) {
              quantityInput.validateQtyRules();
            } else {
              const changeEvent = new Event("change", { bubbles: true });
              input.dispatchEvent(changeEvent);
            }
          }, 0);
        }
      });
    }

    // 更新产品价格
    // 有折扣情况
    const discountFlag = document.querySelector(
      `.sticky-atc-bar .sticky-atc-bar__product-info .f-price--on-sale`,
    )
      ? true
      : false;
    if (discountFlag) {
      const discountPriceElement = document.querySelector(
        ".sticky-atc-bar .sticky-atc-bar__product-info .f-price__sale .f-price-item--sale",
      );
      const regularPriceElement = document.querySelector(
        ".sticky-atc-bar .sticky-atc-bar__product-info .f-price__sale .f-price-item--regular",
      );

      discountPriceElement.textContent = this.formatPrice(
        data.discountPrice * (data.quantity || 1),
      );
      regularPriceElement.innerHTML = `<s>${this.formatPrice(
        data.regularPrice * (data.quantity || 1),
      )} </s>`;
    } else {
      // 没有折扣情况
      const priceElement = document.querySelector(
        ".sticky-atc-bar .sticky-atc-bar__product-info .f-price__regular .f-price-item--regular",
      );
      priceElement.textContent = this.formatPrice(
        data.price * (data.quantity || 1),
      );
    }
  },

  /**
   * HTML 转义，并过滤掉文本中的 HTML 标签及其内部内容
   * 如 <img src=""/>、<div>4343</div> 等会被整体移除，只保留标签外的纯文本
   * @param {string} text - 要转义的文本
   * @returns {string} 转义后的纯文本（已去除标签及标签内内容）
   */
  escapeHtml: function (text) {
    if (text == null || typeof text !== "string") return "";
    const div = document.createElement("div");
    div.innerHTML = text;
    let plain = "";
    for (const node of div.childNodes) {
      if (node.nodeType === Node.TEXT_NODE) {
        plain += node.textContent;
      }
    }
    const escapeDiv = document.createElement("div");
    escapeDiv.textContent = plain;
    return escapeDiv.innerHTML;
  },

  /**
   * 初始化商品小计（从表单获取数据并更新显示）
   * @param {string|HTMLElement} containerId - 容器ID或元素
   * @param {HTMLFormElement|string} form - 表单元素或表单ID
   * @param {string} sectionId - Section ID
   */
  init: function (containerId, form, sectionId) {
    if (typeof form === "string") {
      form = document.getElementById(form) || document.querySelector(form);
    }

    if (!form) {
      console.warn("ProductSummary: Form not found for init");
      return;
    }

    const data = this.getFormData(form);
    if (data) {
      this.updateSummary(containerId, data);
    }

    this.sectionId = this.sectionId || sectionId;
  },

  /**
   * 手动触发更新（供外部调用）
   * @param {string} sectionId - Section ID（可选，不提供则更新所有）
   */
  refresh: function (sectionId) {
    if (sectionId) {
      const container = document.getElementById(`ProductSummary-${sectionId}`);
      if (container) {
        const form =
          container.closest('form[is="product-form"]') ||
          document.getElementById(`product-form-${sectionId}`) ||
          container.closest("form");
        if (form) {
          this.init(container, form);
        }
      }
    } else {
      // 更新所有商品小计
      document
        .querySelectorAll('[id^="ProductSummary-"]')
        .forEach((container) => {
          const sid = container.dataset.sectionId;
          if (sid) {
            const form =
              container.closest('form[is="product-form"]') ||
              document.getElementById(`product-form-${sid}`) ||
              container.closest("form");
            if (form) {
              this.init(container, form);
            }
          }
        });
    }
  },
};

// 防止重复初始化
let productSummaryInitialized = false;

// 防抖函数
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// 更新商品小计的防抖函数
const debouncedUpdateSummary = debounce(function (sectionId) {
  if (sectionId) {
    const container = document.getElementById(`ProductSummary-${sectionId}`);
    if (container) {
      const form =
        container.closest('form[is="product-form"]') ||
        document.getElementById(`product-form-${sectionId}`) ||
        container.closest("form");
      if (form) {
        window.ProductSummary.init(container, form);
      }
    }
  } else {
    // 更新所有商品小计
    document
      .querySelectorAll('[id^="ProductSummary-"]')
      .forEach((container) => {
        const sid = container.dataset.sectionId;
        if (sid) {
          const form =
            container.closest('form[is="product-form"]') ||
            document.getElementById(`product-form-${sid}`) ||
            container.closest("form");
          if (form) {
            window.ProductSummary.init(container, form);
          }
        }
      });
  }
}, 500);

// 自动初始化所有商品小计组件
function initProductSummary() {
  if (productSummaryInitialized) return;
  productSummaryInitialized = true;

  // 初始化所有已存在的商品小计
  document.querySelectorAll('[id^="ProductSummary-"]').forEach((container) => {
    const sectionId = container.dataset.sectionId;
    if (sectionId) {
      const form =
        container.closest('form[is="product-form"]') ||
        document.getElementById(`product-form-${sectionId}`) ||
        container.closest("form");
      if (form) {
        window.ProductSummary.init(container, form, sectionId);
      }
    }
  });

  // // 监听 variant 变化事件（使用事件委托，确保能捕获到动态创建的事件）
  // document.addEventListener('variant:changed', function(event) {
  //   const variant = event.detail?.variant;
  //   if (variant) {
  //     // 找到相关的商品小计容器并更新
  //     document.querySelectorAll('[id^="ProductSummary-"]').forEach(container => {
  //       const sectionId = container.dataset.sectionId;
  //       if (sectionId) {
  //         debouncedUpdateSummary(sectionId);
  //       }
  //     });
  //   }
  // }, true); // 使用捕获阶段，确保能捕获到事件

  // 监听 .product__block--@app 元素的点击事件
  const productInfoElement = document.querySelector(
    `#ProductInfo-${window.ProductSummary.sectionId}`,
  );
  if (productInfoElement) {
    productInfoElement.addEventListener(
      "click",
      function (e) {
        debouncedUpdateSummary(window.ProductSummary.sectionId);
      },
      true,
    ); // 使用捕获阶段
  }

  // 监听 FoxTheme variant change 事件
  if (window.FoxTheme && window.FoxTheme.pubsub) {
    FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
      function (event) {
        const variant = event.data?.variant;
        if (variant) {
          document
            .querySelectorAll('[id^="ProductSummary-"]')
            .forEach((container) => {
              const sectionId = container.dataset.sectionId;
              if (sectionId && event.data.sectionId === sectionId) {
                const form =
                  container.closest('form[is="product-form"]') ||
                  document.getElementById(`product-form-${sectionId}`) ||
                  container.closest("form");
                if (form) {
                  window.ProductSummary.init(container, form);
                }
              }
            });
        }
      },
    );
  }

  // 监听数量变化
  document.addEventListener("change", function (event) {
    if (
      event.target.matches('input[name="quantity"]') ||
      event.target.closest("quantity-input input")
    ) {
      const form =
        event.target.closest('form[is="product-form"]') ||
        event.target.closest("form");
      if (form && form.dataset.sectionId) {
        const container =
          form.querySelector('[id^="ProductSummary-"]') ||
          document.querySelector(
            `[id^="ProductSummary-"][data-section-id="${form.dataset.sectionId}"]`,
          );
        if (container) {
          window.ProductSummary.init(container, form);
          // 更新所有 quantity-input 组件状态
          window.ProductSummary.updateQuantityInputs(
            form.dataset.sectionId,
            parseInt(event.target.value),
          );
        }
      } else {
        // 底部黏栏 触发数量更新
        const sectionId = window.ProductSummary.sectionId;
        const formQuantityInput = document.getElementById(
          `Quantity-${sectionId}`,
        );
        if (formQuantityInput) {
          formQuantityInput.value = event.target.value;
          debouncedUpdateSummary(sectionId);
          // 更新所有 quantity-input 组件状态
          window.ProductSummary.updateQuantityInputs(
            sectionId,
            parseInt(event.target.value),
          );
        }
      }
    }
  });
}

function modifyForm() {
  window.setTimeout(() => {
    const product = document.querySelector(".product");
    if (!product) return;
    const fields = product.querySelectorAll("input[name], select[name]");
    fields.forEach((field) => {
      const originalName = field.getAttribute("name");
      if (!originalName) return;
      // 去除 name 中的 HTML 标签片段及残留尖括号字符
      const sanitizedName = originalName
        .replace(/<[^>]*>/g, "")
        .replace(/[<>]/g, "")
        .trim();
      if (sanitizedName && sanitizedName !== originalName) {
        field.setAttribute("name", sanitizedName);
        field.name = sanitizedName;
      }
    });
  }, 2000);
}

// 显示立刻支付按钮-start
/**
 * 1. 表单校验函数
 * @param {HTMLFormElement} formElement - Shopify 的主产品表单对象
 * @returns {boolean} - 是否校验通过
 */
function updateBuyItNowButton() {
  const formElement =
    document.querySelector('form[action="/cart/add"]');

  if (!formElement) {
    console.error('未找到指定的产品表单');
    return;
  }

  // 使用浏览器原生的 H5 表单校验机制（会检查 required、pattern、min/max 等）
  if (formElement.checkValidity && !formElement.checkValidity()) {
    // 如果校验未通过，自动聚焦到第一个报错的必填项，并弹出浏览器原生的气泡提示
    // formElement.reportValidity();
    // 重新隐藏
    const paymentWrapper = document.querySelector('[data-shopify="payment-button"]');
    if (paymentWrapper && paymentWrapper.style.display !== 'none') {
      paymentWrapper.style.setProperty('display', 'none', 'important');
      paymentWrapper.style.setProperty('pointer-events', 'none', 'important');
    }
  } else {
     // 匹配我们在控制台看到的 Shopify 官方生成的原生按钮容器
    const paymentWrapper = document.querySelector('[data-shopify="payment-button"]');
    
    if (paymentWrapper) {
      // 移除 Shopify 官方注入的隐藏 class
      paymentWrapper.classList.remove('hide');
      
      // 强行覆盖行内样式 display: none 和禁用点击的限制
      paymentWrapper.style.setProperty('display', 'block', 'important');
      paymentWrapper.style.setProperty('pointer-events', 'auto', 'important');
      
      console.log('Shopify 原生动态结账按钮已成功唤醒并显示');
    } else {
      console.warn('未能在 DOM 中找到带有 data-shopify="payment-button" 的元素');
    }
  }
}

/**
 * 2. 显示原生“立刻购买”按钮函数
 */
// function showNativePaymentButton() {
//   // 匹配我们在控制台看到的 Shopify 官方生成的原生按钮容器
//   const paymentWrapper = document.querySelector('[data-shopify="payment-button"]');
  
//   if (paymentWrapper) {
//     // 移除 Shopify 官方注入的隐藏 class
//     paymentWrapper.classList.remove('hide');
    
//     // 强行覆盖行内样式 display: none 和禁用点击的限制
//     paymentWrapper.style.setProperty('display', 'block', 'important');
//     paymentWrapper.style.setProperty('pointer-events', 'auto', 'important');
    
//     console.log('Shopify 原生动态结账按钮已成功唤醒并显示');
//   } else {
//     console.warn('未能在 DOM 中找到带有 data-shopify="payment-button" 的元素');
//   }
// }
// 显示立刻支付按钮-end

// DOMContentLoaded 时初始化
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProductSummary);
} else {
  initProductSummary();
}

if (document.readyState != "complete") {
  document.addEventListener("DOMContentLoaded", modifyForm);
} else {
  modifyForm();
}
console.log("document.readyState", document.readyState);
